var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVueJs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175 36.2166C174.404 38.1339 174.202 39.8423 173.4 41.195C154.369 73.3167 135.231 105.372 116.218 137.505C111.675 145.182 107.525 153.093 103.144 160.865C102.367 162.24 101.33 163.472 100.248 165C75.1508 122.045 50.2888 79.4939 25 36.2129H53.6513C53.6807 36.5098 53.6145 36.8654 53.7543 37.0964C65.9352 57.2339 78.1307 77.3603 90.319 97.4941C93.5785 102.883 96.8122 108.287 100.41 114.266C101.904 111.931 102.901 110.472 103.798 108.958C114.651 90.6057 125.493 72.2536 136.324 53.8904C139.789 48.0138 143.2 42.1079 146.636 36.2166H175Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.636 36.2161C143.2 42.1073 139.789 48.0133 136.324 53.8899C125.493 72.2531 114.651 90.6052 103.798 108.957C102.901 110.471 101.904 111.93 100.41 114.266C96.8122 108.286 93.5785 102.883 90.319 97.4936C78.1307 77.3598 65.9352 57.2334 53.7543 37.0959C53.6145 36.8649 53.6807 36.5093 53.6513 36.2124C62.0539 36.1684 70.4602 36.0254 78.8592 36.1684C80.1505 36.1904 81.9531 37.1949 82.6116 38.2874C88.1374 47.4414 93.4497 56.7274 98.843 65.9622C99.1373 66.4644 99.5714 66.886 100.498 68.0371C103.397 63.11 106.127 58.5311 108.802 53.9193C111.52 49.2341 114.224 44.5379 116.859 39.8051C118.271 37.2719 120.059 35.9008 123.23 36.0034C131.026 36.2564 138.833 36.1684 146.636 36.2161Z",
    fill: "#5D6263"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 129,
    fill: "white",
    transform: "translate(25 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVueJs);
export default __webpack_public_path__ + "static/media/Vue.Js.a8ff0e0c2405462a96d5711a83c828f0.svg";
export { ForwardRef as ReactComponent };